import trackingEventDictionary from "@core/dictionary/tracking-event";
import { getApiUrl } from "@utils/baseUrl";

export const tradeLaneTabs = [
  {
    id: "overview",
    text: "Port to Port Pairs",
    isExcludeFilter: true,
  },
  {
    id: "freight_forwarder",
    text: "Freight Forwarders",
    countEnum: "freightForwarderCount",
    redirectionEnum: "freightForwarder",
  },
  {
    id: "vocc",
    text: "VOCC",
    countEnum: "voccCount",
    redirectionEnum: "vocc",
  },
  {
    id: "nvocc",
    text: "NVOCC",
    countEnum: "nvoccCount",
    redirectionEnum: "nvocc",
  },
  {
    id: "importers",
    text: "Consignee",
    countEnum: "importersCount",
  },
  {
    id: "exporters",
    text: "Shippers",
    countEnum: "exportersCount",
  },
  {
    id: "vessel",
    text: "Vessels",
    countEnum: "vesselCount",
    redirectionEnum: "vessel",
  },
];

export const targetSVG = "M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z";

export const apiEndPoints = {
  getProfileHeaderDetails: getApiUrl("profileDetails"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  getMapData: getApiUrl("profileMapData"),
  getShipperDetails: getApiUrl("profileMapData"),
  getProfileSlug: getApiUrl("getProfileSlugID"),
};

export const profileCategory = "trade_lane";

export const tradeLaneEvents = {
  freight_forwarder: {
    tab: trackingEventDictionary.tradeFrieghtForwardersTab,
    tabDownload: trackingEventDictionary.tradeFrieghtForwardersTabDownload,
    profileClick: trackingEventDictionary.tradeFrieghtForwardersTabFrieghtForwardersProfileClick,
    viewShipments: trackingEventDictionary.tradefrieghtForwardersTabfrieghtForwardersProfileViewShipments,
  },
  vocc: {
    tab: trackingEventDictionary.tradeVoccTab,
    tabDownload: trackingEventDictionary.tradeVoccTabDownload,
    profileClick: trackingEventDictionary.tradeVoccTabVoccProfileClick,
    viewShipments: trackingEventDictionary.tradeVoccTabVoccProfileViewShipments,
  },
  nvocc: {
    tab: trackingEventDictionary.tradeNvoccTab,
    tabDownload: trackingEventDictionary.tradeNvoccTabDownload,
    profileClick: trackingEventDictionary.tradeNvoccTabNvoccProfileClick,
    viewShipments: trackingEventDictionary.tradeNvoccTabNvoccProfileViewShipments,
  },
  importers: {
    tab: trackingEventDictionary.tradeImportersTab,
    tabDownload: trackingEventDictionary.tradeImportersTabDownload,
    profileClick: trackingEventDictionary.tradeImportersTabImportersProfileClick,
    viewShipments: trackingEventDictionary.tradeImportersTabImportersProfileViewShipments,
  },
  exporters: {
    tab: trackingEventDictionary.tradeExportersTab,
    tabDownload: trackingEventDictionary.tradeExportersTabDownload,
    profileClick: trackingEventDictionary.tradeExportersTabExportersProfileClick,
    viewShipments: trackingEventDictionary.tradeExportersTabExportersProfileViewShipments,
  },
  vessel: {
    tab: trackingEventDictionary.tradeVesselTab,
    tabDownload: trackingEventDictionary.tradeVesselTabDownload,
  },
  overview: {
    tab: trackingEventDictionary.tradeOverViewTab,
    tradeLanes: trackingEventDictionary.tradeOverviewTabTradeLanes,
    tradeCountries: trackingEventDictionary.tradeOverviewTabTradeCountries,
    portOfLading: trackingEventDictionary.tradeOverviewTabAsPortOfLading,
    portOfUnLading: trackingEventDictionary.tradeOverviewTabAsPortOfUnLading,
  },
  landing: trackingEventDictionary.landing,
  viewShipments: trackingEventDictionary.viewShipments,
};
